module.exports = __webpack_public_path__ + "static/media/coach-matthieu.9d9d1c6c.png";